module.exports = __webpack_public_path__ + "static/media/bj.c81e8915.svg";